// import * as jsts from 'jsts';
import * as jstsIo from 'jsts/org/locationtech/jts/io';
import * as jstsOverlay from 'jsts/org/locationtech/jts/operation/overlay';
import { LinearRing, LineString, MultiLineString, MultiPoint, MultiPolygon, Point, Polygon, } from 'ol/geom';
import * as i0 from "@angular/core";
var JstsService = /** @class */ (function () {
    function JstsService() {
    }
    JstsService.prototype.getJstsParser = function () {
        var parser = new jstsIo.OL3Parser();
        parser.inject(Point, LineString, LinearRing, Polygon, MultiPoint, MultiLineString, MultiPolygon);
        return parser;
    };
    JstsService.prototype.getJstsOverlayOp = function () {
        // const overlayOp = new jstsOverlay.overlay.OverlayOp();
        var overlayOp = jstsOverlay.OverlayOp;
        return overlayOp;
    };
    JstsService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function JstsService_Factory() { return new JstsService(); }, token: JstsService, providedIn: "root" });
    return JstsService;
}());
export { JstsService };
